import { render, staticRenderFns } from "./ReceptionRecipientEditor.vue?vue&type=template&id=7c67ea6e&scoped=true&"
import script from "./ReceptionRecipientEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionRecipientEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionRecipientEditor.vue?vue&type=style&index=0&id=7c67ea6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c67ea6e",
  null
  
)

export default component.exports